
import { Link } from 'react-router-dom';

const MainPage = () => {
    return (
        <div className="main-page">
            <h1>Welcome to the Main Page</h1>
            <p>This is the main content of the application.</p>
            <Link to="/data-privacy">Data Privacy</Link>
        </div>
    )
};

export default MainPage;